export const canvasEventTargets = [
  'ai-agent-dialog',
  'ai-agent-dialog-cancel-button',
  'ai-agent-dialog-editor',
  'ai-generate-dialog',
  'ai-generate-cancel-button',
  'ai-generate-dialog-sources',
  'anchor',
  'board',
  'command-palette-modal',
  'command-palette-cancel-button',
  'command-palette-submit-button',
  'comment-avatar',
  'comment-bubble',
  'comment-bubble-close-button',
  'comment-sidebar-panel-close',
  'comment-thread',
  'comment-thread-container',
  'comment-thread-dialog',
  'comments-sidebar',
  'configure-action-menu',
  'context-menu',
  'controls-menu',
  'create-menu',
  'dev-ui',
  'dev-navbar',
  'dev-panel',
  'editor-container',
  'editor-content',
  'editor-popup',
  'editor-typeahead',
  'emoji-picker-container',
  'export-file-menu',
  'more-shapes-sidebar',
  'export-menu',
  'floating-toolbar',
  'follow-status',
  'handle-bottom',
  'handle-bottomcenterleft',
  'handle-bottomcenterright',
  'handle-bottomleft',
  'handle-bottomright',
  'handle-left',
  'handle-leftcentertop',
  'handle-leftcenterbottom',
  'handle-right',
  'handle-rightcentertop',
  'handle-rightcenterbottom',
  'handle-top',
  'handle-topcenterleft',
  'handle-topcenterright',
  'handle-topleft',
  'handle-topright',
  'handle',
  'image',
  'issue-link-menu',
  'jira-import-button',
  'jira-import-close-button',
  'jira-import-drawer-close-button',
  'jira-import-modal',
  'jira-import-drawer',
  'modal',
  'more-menu',
  'more-menu-submenu',
  'navigation',
  'none',
  'preferences-sidebar',
  'popup-menu',
  'section-title',
  'shape-picker',
  'side-nav',
  'smart-connector-link-button',
  'create-path-label-button',
  'relationship-label',
  'resize-handle',
  'rotate-topleft',
  'rotate-topright',
  'rotate-bottomleft',
  'rotate-bottomright',
  'smart-link-picker',
  'smart-link',
  'stamp-item',
  'sticker-item',
  'sticky-tool-toggle-author-button',
  'template-picker-close-button',
  'template-picker-modal',
  'toolbar-variant-picker',
  'toolbar',
  'snackbar',
  'static-ui-layer',
  'pdf-importer-dialog',
  'voting-sidebar',
  'private-mode-sidebar',
  'timer-modal',
  'text-tool-text-variant-button',
  'text-tool-card-variant-button',
  'find-replace-dialog',
  'bifrost-overlay',
  'ai-first-creation-prompt',
  'rovo-mini-modal',
  'dev-ui-agent-content-generator-input',
  'cloud-architecture-icon-picker',
  'cloud-shapes-spotlight',
  'database-drawer-panel',
  'database-scrollable-inner-container',
  'section-action-drawer',
  'slides-filmstrip',
  'slides-navigator',
  /**
   * ⚠️ For future DOM event targets, add to uiTargets and consider whether you can paste into them
   * and if so, add them to the isExternalPaste guard
   */
] as const;

export type CanvasEventTarget = (typeof canvasEventTargets)[number];

export type CanvasEventTargetFilter = (target: EventTarget) => boolean;
